import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueRouter from 'vue-router'
import router from './router';
import VuetifyToast from 'vuetify-toast-snackbar-ng';
import VueResource from 'vue-resource';
import { vuei18n } from './plugins/i18n';
import properties from './properties';
import ConfigReader from './lib/config-reader';
import auth from './plugins/auth';
import store from './plugins/store';
import vuetifyToastOptions from './plugins/vuetify-toast-options';
import pageTitleMixin from './plugins/page-title';
import Chartkick from '@/plugins/chartkick';

Vue.use(VueRouter);
Vue.use(VueResource);

Vue.http.options.root = ConfigReader.value('apiHost');
Vue.http.options.timeout = 20000;
Vue.http.options.credentials = true;

Vue.config.productionTip = false

Vue.prototype.$properties = properties;
Vue.prototype.$auth = auth;

auth.setupRouter(router, {
  notAuthorizedRedirectRoute: 'NotFound'
});
auth.init();

Vue.use(VuetifyToast, vuetifyToastOptions);

Vue.mixin(pageTitleMixin);

Chartkick.setColors([
  '#50bdc4',
  '#e8a3a3',
  '#eed29b',
  '#bbe292',
  '#a4cdf8',
]);

new Vue({
  vuetify,
  store,
  router,
  i18n: vuei18n,
  render: h => h(App)
}).$mount('#app')
